import type { QueryDefaultsOptions } from '../types';

/** Default stale time in ms. this will be time to auto refetch the data if it is stale.*/
export const DEFAULT_STALE_TIME = 5 * 60 * 1000; // 5 min

/** Default garbage collection time in ms (how long inactive data stays in cache). React Query v5: gcTime (formerly cacheTime). */
export const DEFAULT_GC_TIME = 10 * 60 * 1000; // 10 min

/** gcTime for persisted entities — kept long so cached data survives in localStorage across sessions. */
export const PERSIST_MAX_AGE = 1000 * 60 * 60 * 24; // 24 h

/** localStorage key used by the React Query persister. Must match the `key` option passed to `createAsyncStoragePersister`. */
export const PERSIST_CACHE_KEY = 'REACT_QUERY_OFFLINE_CACHE';

/** Default limit per page for infinite pagination (default: 20). */
export const DEFAULT_LIMIT = 20;

/** Default retry count for infinite pagination (default: 3). */
export const DEFAULT_RETRY = 3;

/** Default options for useQuery/useInfiniteQuery (staleTime, gcTime, refetch behaviour, retry). */
export const DEFAULT_QUERY_OPTIONS: QueryDefaultsOptions = {
  staleTime: DEFAULT_STALE_TIME,
  gcTime: DEFAULT_GC_TIME,
  refetchOnWindowFocus: false,
  refetchOnMount: true,
  retry: DEFAULT_RETRY,
};
